<template>
    <div>
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">{{ $t("products") }}</h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-breadcrumb />
                    </nav>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--6">
            <validation-observer ref="formValidator">
                <form class="new-event--form">
                    <div class="card mb-4">
                        <!-- Card header -->
                        <div class="card-header"><h3 class="mb-0">{{ $t("products") }}</h3></div>
						 <!-- Card body -->
                        <div class="card-body">
                            <!-- Form groups used in grid -->
                            <div class="row">
                                <div class="col-md-6">
                                    <base-input :label="$t('name')" :name="$t('name')" :value="params.name" rules="required" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <base-input :label="$t('product_code')" :name="$t('product_code')" :value="params.code" rules="required" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <base-input :label="$t('shipping_cost')" :name="$t('shipping_cost')" :value="params.shipping_cost" rules="required" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <base-input :label="$t('detail')">
                                        <textarea class="form-control" rows="3" :value="params.detail" ></textarea>
                                    </base-input>
                                </div>
                            </div>

                            <!-- <div class="row">
                                <div class="col-md-6">
                                    <base-input :label="$t('price')" :name="$t('price')" v-model.number="params.price" rules="required|numeric" />
                                </div>
                            </div> -->

                            <div class="row">
                                <div class="col-md-12">
									<img :src="GetProductUrl(params.images)" height="200px" v-if="params.images.includes('.png') || params.images.includes('.jpg') || params.images.includes('jpeg')"/>
                                </div>
                            </div>

							<!-- Variable -->
                            <!-- <div class="row py-4">
                                <div class="col-md-1 pb-3">
                                    Variable
                                </div>
                                <div class="col-md-6">
                                    <base-button size="sm" v-if="attributes.length < 12" @click="handleAddVariable()" >Add Variable</base-button >
                                </div>
                            </div> -->

                            <div class="row">
                                <div class="col-md-12">
                                    <div v-for="(sku, index) in products_sku" :key="index" class="row py-2" >
                                        <div class="col-md-6 col-lg-3">
                                            <base-input v-model="sku.sku_name" size="sm"/>
                                        </div>
                                        <div class="col-md-6 col-lg-3">
                                            <base-input v-model="sku.sku_code" size="sm"/>
                                        </div>

                                        <div class="col-md-6 col-lg-3">
                                            <base-button @click="handleMapWms(index)" type="primary">
                                                <i class="fa fa-plus"></i>WMS
											</base-button>
                                        </div>

										<!-- Product -->
                                        <div class="col-md-12 col-lg-12">
                                            <span v-for="(option, index) in sku.wms_map" class="badge badge-pill badge-primary text-white mr-2 py-2 pb-2" :key="index">
												{{ GetProductName(option) }} x {{ option.pickup_quantity }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <hr />
                            <div class="row">
                                <div class="col-md-12">
                                    <base-button @click="handleSaveProduct()" type="primary" >{{ $t("save") }}</base-button >
                                    <base-button @click="$router.go(-1)" type="primary" >{{ $t("back") }}</base-button >
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </div>

		<!-- Variable Modal -->
        <modal :show="showAddVariable" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
					<div class="col md-3">
						<base-input :label="$t('name')" v-model="variableName"></base-input>
					</div>
            </form>

            <template slot="footer">
                <button type="submit" class="btn btn-md btn-primary" @click="handleUpdateVariable()" > {{ $t("add") }} </button>
                <button type="button" class="btn btn-md btn-link ml-auto" @click="showAddVariable = false" > {{ $t("close") }} </button>
            </template>
        </modal>

		<!-- Option Modal	-->
        <modal :show="showManageOption" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
                <label for="">Variable : {{ attr.variable }}</label>
                <div class="row pb-3">
					<div class="col-md-10">
                        <base-input>
                            <el-select v-model="wms_product_id" :placeholder="$t('product')" :label="$t('product')" filterable @change="handleWmsMapChange">
                                <el-option v-for="option in WmsProductTable" :key="option.ID" :label="option.Name" :value="option.ID"/>
                            </el-select>
                        </base-input>
                    </div>

                    <div class="col-md-2">
                        <base-button size="md" @click="handleAddOption()" type="primary" > <i class="fa fa-plus"></i ></base-button>
                    </div>
                </div>

                <div class="row pb-3">
					<div class="col-md-10">
						<base-input>
							<el-select v-model="bo_product_random" value-key="id"  :placeholder="$t('product_random')" :label="$t('product_random')" filterable>
								<el-option v-for="(option,index) in SkuRandomTable"  :key="index" :label="option.name" :value="option"/>
							</el-select>
						</base-input>
					</div>

					<div class="col-md-2">
						<base-button size="md" @click="handleAddRandomOption()" type="primary" > <i class="fa fa-plus"></i ></base-button>
					</div>
				</div>

				<!-- option (wms) -->
				<div class="row py-2" v-for="(option,index) in attr.options" :key="index">
					<div class="col-md-10">
						{{ option.name }}
					</div>
					<div class="col-md-2">
						<base-button size="md" @click="handleRemoveOption(attr.options,index)" type="danger" > <i class="fa fa-trash"></i ></base-button>
					</div>
				</div>

            </form>

            <template slot="footer">
                <button type="button" class="btn btn-md btn-link ml-auto" @click="showManageOption = false" >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>

        <modal :show="showMapWms" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
                <label for="">WMS Map</label>

                <div class="row pb-3">
                    <div class="col-md-7">
                        <base-input>
                            <el-select v-model="wms_product_id" :placeholder="$t('product')" :label="$t('product')" filterable >
                                <el-option v-for="option in WmsProductTable" :key="option.ID" :label="option.Name" :value="option.ID" > </el-option>
                            </el-select>
                        </base-input>
                    </div>
                    <div class="col-md-3">
                        <base-input :placeholder="$t('quantity')" v-model="quantity" > </base-input>
                    </div>
                    <div class="col-md-2">
                        <base-button size="md" @click="handleAddWmsProduct()" type="primary" ><i class="fa fa-plus"></i></base-button>
                    </div>
                </div>

				<div class="row pb-3">
                    <div class="col-md-7">
                        <base-input>
                            <el-select v-model="bo_product_random" value-key="id"  :placeholder="$t('product_random')" :label="$t('product_random')" filterable >
								<el-option v-for="(option,index) in SkuRandomTable"  :key="index" :label="option.name" :value="option"/>
                            </el-select>
                        </base-input>
                    </div>
                    <div class="col-md-3">
                        <base-input :placeholder="$t('quantity')" v-model="bo_random_quantity" > </base-input>
                    </div>
                    <div class="col-md-2">
                        <base-button size="md" @click="handleAddRandomProduct()" type="primary" ><i class="fa fa-plus"></i></base-button>
                    </div>
                </div>

                <div class="row">
                    <div
                        class="col-md-10"
                        v-if="products_sku[product_sku_index] != undefined"
                    >
                        <div
                            v-for="(option, index) in products_sku[
                                product_sku_index
                            ].wms_map"
                            :key="index"
                            class="row"
                        >
                            <div class="col-md-10 pb-3">
                                {{ GetProductName(option) }} -
                                {{ option.pickup_quantity }}
                            </div>
                            <div class="col-md-2">
                                <base-button
                                    size="sm"
                                    @click="handleRemoveWmsProduct(index)"
                                    type="danger"
                                >
                                    <i class="fa fa-trash"></i
                                ></base-button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <template slot="footer">
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showMapWms = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>
    </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import FileInput from "@/components/Inputs/FileInput";
import { mapGetters, mapActions } from "vuex";
import swal from "sweetalert2";

export default {
    name: "form-platform-products",
    components: {
        FileInput,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    data() {
        return {
            showAddVariable: false,
            showManageOption: false,
            showMapWms: false,
            variableName: "",
            attr: [],
            attr_option: {
				name: "",
				wms_map: []
			},
            products_sku: [],
            params: {
                id: 0,
                name: "",
                detail: "",
                price: "",
                images: "",
                code: "",
                attributes: "",
                tag: "",
                status: "",
                bo_product_category_id: 1,
                products_sku: null,
				platform_product_id:"",
				platform_id:0,
				shipping_cost:0,

            },
            attributes: [],
            sku: {},
            selectedWmsProduct: 0,
            wms_product_id: "",
            bo_product_random: "",
            quantity: "",
			bo_random_quantity: "",
            product_sku_index: 0,
            inputs: {
                file: []
            },
            ProductStatusTable: [
                { id: 1, name: "ใช้งาน" },
                { id: 2, name: "ไม่ใช้งาน" }
            ],
            sku_file_index: 0
        };
    },
    computed: {
        ...mapGetters({
            WmsProductTable: "WmsProduct/getData",
            SkuRandomTable: "Product/getDataSkuRandom",
            ProductCategoryTable: "ProductCategory/getData"
        })
    },
 	async  mounted() {
		let documentClasses = document.body.classList;
		documentClasses.remove("modal-open");
		let p = this.$route.params.params;
		console.log(p)
		this.params.id = p.id;
		this.params.name = p.name;
		this.params.detail = p.detail;
		this.params.price = p.price;
		this.params.images = p.images;
		this.params.code = p.code;
		this.params.platform_id = p.platfrom_id;


        this.listWMS();
		this.listSkuRandom();
        this.listProductCategory();
		try {
			let resp = await this.getDetail(this.params.id)
			let detail = resp.data.Datum
			this.products_sku = detail.products_sku

			// sku_map   string to struct
			this.products_sku.forEach(e => {
				if (e.wms_map == "")
				{
					e.wms_map = []
				} else {
					e.wms_map = JSON.parse(e.wms_map)
				}
			});

		} catch (err) {
			console.log(err)
		}


    },
    methods: {
        ...mapActions({
            createData: "Product/createData",
            updateData: "Product/updateData",
			updatePlatformData:"Product/updatePlatformData",
            listWMS: "WmsProduct/listData",
            listProductCategory: "ProductCategory/listData",
			getDetail:"Product/getDetail",
            listSkuRandom: "Product/listSkuRandom",
        }),
        GetProductName(option) {

			if (option.wms_product_id == 0){
				let random = this.SkuRandomTable.find(s => {
					return s.id == option.wms_product_random.bo_product_random_id;
				});

				if (random == undefined) {
					return "";
				} else {
					return random.name;
				}

			} else {
				let product = this.WmsProductTable.find(s => {
					return s.ID == option.wms_product_id;
				});
				if (product == undefined) {
					return "";
				} else {
					return product.Name;
				}
			}
        },
        async handleSaveProduct() {
            let valid = await this.$refs.formValidator.validate();
            if (!valid) return;

			// this.params.wms_map = this.params.wms_map_st
			this.params.products_sku = this.products_sku

			this.updatePlatformData({ id: this.params.id, payload: this.params })
				.then(resp => {
					swal.fire({
						title: this.$t("edit_success"),
						text: ``,
						icon: "success",
						confirmButtonClass: "btn btn-success btn-fill",
						buttonsStyling: false
					});
					this.$router.push({ path: "/admin/product/" + this.$route.params.platform });
				})
				.catch(err => {
					swal.fire({
						title: this.$t(err.response.data.Msg),
						text: "",
						icon: "error",
						confirmButtonClass: "btn btn-danger btn-fill",
						buttonsStyling: false
					});
				});

        },

		// Manage Variable
        handleAddVariable() {
            this.variableName = "";
            this.showAddVariable = true;
        },
        handleUpdateVariable() {
            this.showAddVariable = false;

            this.attributes.push({
                variable: this.variableName,
                options: []
            });
        },
        handleRemoveVariable(index) {
            this.attributes.splice(index, 1);
        },
		handleCopyVariable(index){
			let attribute = JSON.parse(JSON.stringify(this.attributes[index]))
            this.attributes.push(attribute);
		},

		// ManageOption
        handleManageOption(attribute) {
            this.showManageOption = true;
			this.attr = attribute

			this.attr_option = {
				name: "",
				wms_map: []
			}
        },
        handleAddOption() {
			//add new
			this.attr_option.name = this.WmsProductTable.find(s => {
				return s.ID == this.wms_product_id;
			}).ManPN;

			this.attr_option.wms_map = [];
			this.attr_option.wms_map.push({
				wms_product_id: this.wms_product_id,
				wms_product_name: this.WmsProductTable.find(s => {
					return s.ID == this.wms_product_id;
				}).Name,
				wms_product_random : {
					bo_product_random_id: 0,
				},
				pickup_quantity: 1
			})

			this.attr.options.push(JSON.parse(JSON.stringify(this.attr_option)))



        },

		handleAddRandomOption(){
			try {

			this.attr_option.name = this.bo_product_random.name
			this.attr_option.wms_map = [];
			this.attr_option.wms_map.push({
				wms_product_id: 0,
				wms_product_name: this.bo_product_random.name,
				pickup_quantity: 1,
				wms_product_random : {
					bo_product_random_id: this.bo_product_random.id,
				}
			})

			this.attr.options.push(JSON.parse(JSON.stringify(this.attr_option)))
			}
			catch (err){
				console.log("Add Random Error : ",err)
			}

		},
        handleRemoveOption(options, index) {
			options.splice(index, 1);
        },
        
		handleWmsMapChange(){
			// set option name with wms_product_id
			try {
				this.attr_option.name = this.WmsProductTable.find(
					s => s.ID == this.wms_product_id
				).Name;
				console.log(this.attr_option.name)
			}
			catch(err){
				console.log(err)
			}

		},

        handleMapWms(product_sku_index) {
            this.showMapWms = true;
			this.quantity = 1;
			this.bo_random_quantity = 1;
            this.product_sku_index = product_sku_index;
        },
        handleAddWmsProduct() {

			console.log("Wms Add ",this.wms_product_id)

			if (this.products_sku[this.product_sku_index].wms_map == null || this.products_sku[this.product_sku_index].wms_map == undefined || this.products_sku[this.product_sku_index].wms_map == "" ) 
			{
				this.products_sku[this.product_sku_index].wms_map = []
				this.products_sku[this.product_sku_index].wms_map.push({
                    wms_product_id: this.wms_product_id,
                    pickup_quantity: parseInt(this.quantity),
					wms_product_random : {
						bo_product_random_id: 0,
					}
                });

				return
			}

            let sku = this.products_sku[this.product_sku_index].wms_map.find(
                s => s.wms_product_id == this.wms_product_id
            );


            if (sku == undefined) {
				console.log("Push maps  ",this.wms_product_id)
                this.products_sku[this.product_sku_index].wms_map.push({
                    wms_product_id: this.wms_product_id,
                    pickup_quantity: parseInt(this.quantity),
					wms_product_random : {
						bo_product_random_id: 0,
					}
                });
            } else {
				console.log("Update quantity  ",this.wms_product_id)
                sku.pickup_quantity = parseInt(this.quantity);
            }
        },
		handleAddRandomProduct(){
			console.log("Add Product Random",this.bo_product_random)

			if (this.products_sku[this.product_sku_index].wms_map == null || this.products_sku[this.product_sku_index].wms_map == undefined || this.products_sku[this.product_sku_index].wms_map == "" ) 
			{
				// first variable
				this.products_sku[this.product_sku_index].wms_map = []
				this.products_sku[this.product_sku_index].wms_map.push({
                    wms_product_id: 0,
                    pickup_quantity: parseInt(this.bo_random_quantity),
					wms_product_random : {
						bo_product_random_id: this.bo_product_random.id,
					}
                });

				return
			}

            let sku = this.products_sku[this.product_sku_index].wms_map.find((s)=>{
				try {
					return s.wms_product_random.bo_product_random_id == this.bo_product_random.id
				} catch (err) {
					console.log(err)
					return false
				}	
			});


            if (sku == undefined) {
				console.log("Push maps random  ",this.bo_product_random)
                this.products_sku[this.product_sku_index].wms_map.push({
					wms_product_id: 0,
                    pickup_quantity: parseInt(this.bo_random_quantity),
					wms_product_random : {
						bo_product_random_id: this.bo_product_random.id,
					}
                });
            } else {
				console.log("Update quantity random ",this.bo_product_random)
                sku.pickup_quantity = parseInt(this.bo_random_quantity);
            }
		},
        handleRemoveWmsProduct(index) {
            this.products_sku[this.product_sku_index].wms_map.splice(index, 1);
        },

        filesChange(files) {
            if (files[0].type != "image/png" && files[0].type != "image/jpeg") {
                swal.fire({
                    title: "Error",
                    text: "กรุณาเลือกไฟล์รูปภาพ",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }

			console.log(files[0].size)

			if (files[0].size > 1024 * 1024 *2) {
				swal.fire({
                    title: "Error",
                    text: "ขนาดไฟล์รูปภาพต้องไม่เกิน 2 MB",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
			}
            // convert to base64
            const reader = new FileReader();
            reader.readAsDataURL(files[0]);
            reader.onload = () => {
                this.params.images = reader.result;
            };
        },
        SkuFileChange(files) {
			

            if (files[0].type != "image/png" && files[0].type != "image/jpeg") {
                swal.fire({
                    title: "Error",
                    text: "กรุณาเลือกไฟล์รูปภาพ",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }
			console.log(files[0].size)

			if (files[0].size > 1024 * 1024 ) {
				swal.fire({
                    title: "Error",
                    text: "ขนาดไฟล์รูปภาพต้องไม่เกิน 1 MB",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
			}
            // convert to base64
            const reader = new FileReader();
            reader.readAsDataURL(files[0]);
            reader.onload = () => {
                this.products_sku[this.sku_file_index].image = reader.result;
            };
        },
		GetProductUrl(filename){
			if (filename.includes("http")){
				return filename
			}
			return process.env.VUE_APP_API_BASE_URL + "/files/products/" + filename
		},
		fileNameIsImage(filename) {
			return filename.includes(".png") || filename.includes(".jpg") || filename.includes(".jpeg")
		}

    }
};
</script>
